import { FlexRow } from 'modules/ui/components';
import styled from 'styled-components';

export const Tab = styled(FlexRow)`
  background: rgba(140, 255, 255, 0.1);
  border-radius: 20px;
  transition: 0.3s;
  align-items: center;
`;
